import React from 'react'
import BiGlauco from "../components/BiGlauco"

const IndexPage = () => (<BiGlauco/>)

export default IndexPage
